import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { SelectHotelTemplate } from "@/components/features-new/select-hotel-template";

import { useConfirmParams } from "./hooks";

export const SelectHotelTemplatePage = () => {
	const { hotelID } = useConfirmParams();

	if (!hotelID) {
		notifyUserEventInfo({
			title: "無効なURLです",
		});

		return <Navigate to={generatePath(PATHS.TOP)} />;
	}

	return <SelectHotelTemplate hotelID={hotelID} />;
};

SelectHotelTemplatePage.displayName = "SelectHotelTemplatePage";
